import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--surface-overlay);
 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 1.5rem;
  box-sizing: border-box;
`;

export const FormContent = styled.div`
  background: var(--app-bg-gradient);
  border-radius: 12px;
  padding: 30px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px var(--accent-soft);
  position: relative;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: var(--input-bg);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: var(--accent-secondary);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: var(--brand-blue);
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 800;
  color: var(--accent-secondary);
  text-shadow: 0 4px 20px var(--accent-secondary-soft);
  margin: 0 0 1.5rem 0;
  letter-spacing: -0.02em;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: 577px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const Label = styled.label`
  font-size: 1rem;
  font-weight: 500;
  color: var(--accent-secondary); /* Cor do tema */
  min-width: 200px;
  width: 200px;
  text-align: left;
  white-space: normal;
  overflow: visible;
  word-wrap: break-word;
  hyphens: auto;
  line-height: 1.4;
  flex-shrink: 0;

  @media (max-width: 576px) {
    min-width: auto;
    width: 100%;
  }
`;

export const Input = styled.input`
  padding: 0.8rem 1rem;
  border-radius: 8px;
  border: 1px solid var(--accent-secondary-soft);
  background: var(--input-bg);
  color: var(--accent-secondary-soft);
  font-size: 1rem;
  transition: all 0.3s ease;
  flex: 1;
  min-width: 0;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: var(--accent-secondary);
    box-shadow: 0 0 0 2px var(--accent-secondary-soft);
  }

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const RetirementCard = styled.div`
  background: var(--accent-soft);
  border-radius: 8px;
  padding: 1.2rem;
  border: 1px solid var(--border-subtle);
  margin-top: 1rem;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const Checkbox = styled.input`
  width: 1.2rem;
  height: 1.2rem;
  accent-color: var(--accent-secondary);
  cursor: pointer;
`;

export const CheckboxLabel = styled.label`
  color: var(--accent-secondary);
  font-weight: 500;
  cursor: pointer;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const BtnClose = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: var(--accent-secondary);
  cursor: pointer;
  padding: 5px;
  transition: color 0.3s ease;
  z-index: 10;

  &:hover {
    color: var(--brand-blue);
  }
`;

export const BtnCancel = styled.button`
  padding: 0.8rem 1.5rem;
  border-radius: 20px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${props => props.primary ? 'var(--brand-blue)' : 'var(--input-bg)'};
  color: var(--accent-secondary);
  border: ${props => !props.primary ? '1px solid var(--accent-secondary-soft)' : 'none'};
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-sm);
    background: ${props => props.primary ? 'var(--brand-blue)' : 'var(--accent-secondary-soft)'};
  }

  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;


export const BtnRetire = styled.button`
  padding: 0.8rem 1.5rem;
  border-radius: 20px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${props => props.primary ? 'var(--brand-blue)' : 'var(--input-bg)'};
  color: var(--accent-secondary);
  border: ${props => !props.primary ? '1px solid var(--accent-secondary-soft)' : 'none'};
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-sm);
    background: ${props => props.primary ? 'var(--brand-blue)' : 'var(--accent-secondary-soft)'};
  }

  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;